/**
 * @module websocket.utils
 */

export const getWebsocketChannel = (entityId) => {
  return {
    // dashboard
    dashboard: `dashboard-presence`,
    // flight
    flightList: `flight-presence-list`,
    flightDetails: entityId ? `flight-presence-${entityId}` : null,
    // airport
    airportList: `airport-presence-list`,
    airportDetails: entityId ? `airport-presence-${entityId}` : null,
    // aircraft
    aircraftList: `aircraft-presence-list`,
    aircraftDetails: entityId ? `aircraft-presence-${entityId}` : null,
    // user
    userList: `user-presence-list`,
    userDetails: entityId ? `user-presence-${entityId}` : null,
    // pilot
    pilotList: `pilot-presence-list`,
    pilotDetails: entityId ? `pilot-presence-${entityId}` : null,
    // passenger
    passengerList: `passenger-presence-list`,
    passengerDetails: entityId ? `passenger-presence-${entityId}` : null,
    // airline
    airlineList: `airline-presence-list`,
    airlineDetails: entityId ? `airline-presence-${entityId}` : null,
    // flight-crew
    flightCrewList: `flight-crew-presence-list`,
    flightCrewDetails: entityId ? `flight-crew-presence-${entityId}` : null,
    // booking
    bookingList: `booking-presence-list`,
    bookingDetails: entityId ? `booking-presence-${entityId}` : null,
    // baggage
    baggageList: `baggage-presence-list`,
    baggageDetails: entityId ? `baggage-presence-${entityId}` : null,
    // simulation
    simulationList: `simulation-presence-list`,
    simulationDetails: entityId ? `simulation-presence-${entityId}` : null,
  }
}
